import { render, staticRenderFns } from "./AddOPSAdmin.vue?vue&type=template&id=ae09c264"
import script from "./AddOPSAdmin.vue?vue&type=script&lang=js"
export * from "./AddOPSAdmin.vue?vue&type=script&lang=js"
import style0 from "./AddOPSAdmin.vue?vue&type=style&index=0&id=ae09c264&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports